var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFindMate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    role: "img",
    "aria-label": "E\\u015Fini Bul",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fm-face",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7CC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#2A8CF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#145BBE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fm-inner",
    cx: 0.42,
    cy: 0.3,
    r: 0.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4FA8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A6CD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fm-gloss",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fm-card",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3EAF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fm-star",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFE57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5A80E"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fm-bsh",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "150%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fm-osh",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "170%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 8,
    floodColor: "#062B66",
    floodOpacity: 0.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fm-clip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.6,35.0 Q256.0,18.0 285.4,35.0 L432.7,120.0 Q462.1,137.0 462.1,171.0 L462.1,341.0 Q462.1,375.0 432.7,392.0 L285.4,477.0 Q256.0,494.0 226.6,477.0 L79.3,392.0 Q49.9,375.0 49.9,341.0 L49.9,171.0 Q49.9,137.0 79.3,120.0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(256 250) scale(0.9) translate(-256 -256)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 16)",
    fill: "#062B66",
    opacity: 0.4,
    filter: "url(#fm-bsh)",
    d: "M226.6,35.0 Q256.0,18.0 285.4,35.0 L432.7,120.0 Q462.1,137.0 462.1,171.0 L462.1,341.0 Q462.1,375.0 432.7,392.0 L285.4,477.0 Q256.0,494.0 226.6,477.0 L79.3,392.0 Q49.9,375.0 49.9,341.0 L49.9,171.0 Q49.9,137.0 79.3,120.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 8)",
    fill: "#0E4794",
    d: "M226.6,35.0 Q256.0,18.0 285.4,35.0 L432.7,120.0 Q462.1,137.0 462.1,171.0 L462.1,341.0 Q462.1,375.0 432.7,392.0 L285.4,477.0 Q256.0,494.0 226.6,477.0 L79.3,392.0 Q49.9,375.0 49.9,341.0 L49.9,171.0 Q49.9,137.0 79.3,120.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fm-face)",
    d: "M226.6,35.0 Q256.0,18.0 285.4,35.0 L432.7,120.0 Q462.1,137.0 462.1,171.0 L462.1,341.0 Q462.1,375.0 432.7,392.0 L285.4,477.0 Q256.0,494.0 226.6,477.0 L79.3,392.0 Q49.9,375.0 49.9,341.0 L49.9,171.0 Q49.9,137.0 79.3,120.0 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 178,
    fill: "#0E4794",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 252,
    r: 174,
    fill: "url(#fm-inner)",
    stroke: "#FFFFFF",
    strokeOpacity: 0.5,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fm-clip)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 118,
    rx: 210,
    ry: 112,
    fill: "url(#fm-gloss)",
    opacity: 0.55
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#fm-osh)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-12 206 262)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 193,
    width: 110,
    height: 150,
    rx: 16,
    fill: "#A9B8CF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 187,
    width: 110,
    height: 150,
    rx: 16,
    fill: "url(#fm-card)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 198,
    width: 88,
    height: 128,
    rx: 10,
    fill: "#EAF4FF",
    stroke: "#8EC3FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(206 266) scale(34)",
    fill: "url(#fm-star)",
    stroke: "#E08E00",
    strokeWidth: 0.06,
    strokeLinejoin: "round",
    d: "M0.0,-1.0 L0.24,-0.33 L0.95,-0.31 L0.39,0.13 L0.59,0.81 L0.0,0.42 L-0.59,0.81 L-0.39,0.13 L-0.95,-0.31 L-0.24,-0.33 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 194,
    width: 92,
    height: 9,
    rx: 4.5,
    fill: "#FFFFFF",
    opacity: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(12 306 256)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 251,
    y: 187,
    width: 110,
    height: 150,
    rx: 16,
    fill: "#A9B8CF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251,
    y: 181,
    width: 110,
    height: 150,
    rx: 16,
    fill: "url(#fm-card)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 192,
    width: 88,
    height: 128,
    rx: 10,
    fill: "#EAF4FF",
    stroke: "#8EC3FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(306 260) scale(34)",
    fill: "url(#fm-star)",
    stroke: "#E08E00",
    strokeWidth: 0.06,
    strokeLinejoin: "round",
    d: "M0.0,-1.0 L0.24,-0.33 L0.95,-0.31 L0.39,0.13 L0.59,0.81 L0.0,0.42 L-0.59,0.81 L-0.39,0.13 L-0.95,-0.31 L-0.24,-0.33 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 188,
    width: 92,
    height: 9,
    rx: 4.5,
    fill: "#FFFFFF",
    opacity: 0.9
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "translate(256 158) scale(18)",
    fill: "#FFFFFF",
    d: "M0,-1 C0.12,-0.12 0.12,-0.12 1,0 C0.12,0.12 0.12,0.12 0,1 C-0.12,0.12 -0.12,0.12 -1,0 C-0.12,-0.12 -0.12,-0.12 0,-1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(380 346) scale(11)",
    fill: "#FFFFFF",
    opacity: 0.85,
    d: "M0,-1 C0.12,-0.12 0.12,-0.12 1,0 C0.12,0.12 0.12,0.12 0,1 C-0.12,0.12 -0.12,0.12 -1,0 C-0.12,-0.12 -0.12,-0.12 0,-1 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindMate);
export default __webpack_public_path__ + "static/media/find-mate.f64633fb1c956894b5c0dce47ecbbb38.svg";
export { ForwardRef as ReactComponent };